export default {
  newStarRoom: {
    user_no:'用户靓号',
    avatar:'头像',
    nickname:'昵称',
    country:'国家',
    add:'新增',
  }
}



// WEBPACK FOOTER //
// ./src/language/newStarRoom-zh-cn.js